import { NavLink, NavLinkProps } from "react-router-dom";
import { Badge } from "./badge";

export type MenuItemProps = {
  number: number;
  name: string;
  forcedActive?: boolean;
} & Omit<NavLinkProps, "className" | "children">;

export const MenuItem = ({
  number,
  name,
  forcedActive,
  ...props
}: MenuItemProps) => {
  function checkActive(navLinkActive: boolean) {
    return forcedActive !== undefined ? forcedActive : navLinkActive;
  }

  return (
    <NavLink
      className={({
        isActive,
      }) => `w-full h-12 px-6 py-3 border-l-4 justify-between items-center inline-flex cursor-pointer text-sm font-['Raleway'] leading-normal ${checkActive(isActive) ? "border-primary text-primary font-bold bg-[#def2ff]" : "text-slate-700"}
      `}
      {...props}
    >
      {({ isActive }) => (
        <>
          {name}
          <Badge
            variant={checkActive(isActive) ? "containedActive" : "contained"}
          >
            {number}
          </Badge>
        </>
      )}
    </NavLink>
  );
};
